import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_container_trailer_page_list = _resolveComponent("container-trailer-page-list")!

  return (_openBlock(), _createBlock(_component_container_trailer_page_list, {
    list: _ctx.list,
    pageSize: 9999999,
    menuTab: _ctx.menuTab,
    addPower: "OrderManagement_Order_Summary_DestinationPortContainer_Add",
    editPower: "OrderManagement_Order_Summary_DestinationPortContainer_Edit",
    deletePower: "OrderManagement_Order_Summary_DestinationPortContainer_Delete",
    serviceType: _ctx.serviceType,
    orderId: _ctx.$route.params.id
  }, null, 8, ["list", "menuTab", "serviceType", "orderId"]))
}